import { makeStyles } from '@mui/styles';
import { Dialog, DialogContent } from '@mui/material';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
	root: {
		width: '100%',
		'& > * + *': {
			marginTop: theme.spacing(2)
		},
		position: 'fixed',
		inset: '0px',
		zIndex: '10',
		paddingTop: '40vh',
		paddingLeft: '0%'
	},
	spinnerWrapper: {
		display: 'block',
		position: 'relative',
		width: '100%',
		minHeight: '100px',
		height: '100px',
		textAlign: 'center'
	},
	spinner: {
		position: 'relative',
		display: 'inline-block'
	},
	rotatingLogo: {
		width: '128px',
		animation: `$spin 2s linear infinite`
	},
	'@keyframes spin': {
		from: { transform: 'rotate(0deg)' },
		to: { transform: 'rotate(360deg)' }
	}
}));

const Loader = ({ visible }) => {
	const classes = useStyles();

	return (
		visible && (
			<Dialog
					fullWidth={true}
					maxWidth="md"
					open={visible}
					onClose={() => {}}
					disableEscapeKeyDown
					aria-labelledby="max-width-dialog-title"
				>
					<DialogContent>
						{/* Spinner con logo giratorio */}
						<div className={classes.spinnerWrapper}>
							<div className={classes.spinner}>
								<img
									className={classes.rotatingLogo}
									src="assets/images/logos/favicon.ico"
									alt="logo"
								/>
							</div>
						</div>
						<br />
            <br />
						<h2 style={{ textAlign: 'center' }}>...Cargando</h2>
					</DialogContent>
				</Dialog>
		)
	);
};

Loader.propTypes = {
  visible: PropTypes.bool,
};

export default Loader;
